import { render } from "./OfficeDicision.vue?vue&type=template&id=64e3f044&scoped=true"
import script from "./OfficeDicision.vue?vue&type=script&lang=js"
export * from "./OfficeDicision.vue?vue&type=script&lang=js"

import "./OfficeDicision.vue?vue&type=style&index=0&id=64e3f044&lang=scss&scoped=true"
import "./OfficeDicision.vue?vue&type=style&index=1&id=64e3f044&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e3f044"]])

export default __exports__